import classnames from 'classnames';

import style from './ContactPersonCard.module.scss';

import { Input, PhoneInput } from '@components/Input';
import { FoldingComponent } from '@components/FoldingComponent';
import { CancelButton } from '@components/ActionButtons/CancelButton';
import { EhrPageAttributes } from 'chaika-test-attributes';
import { translate } from '@chaika/i18n/helper';
import { assertIsDefined } from '@utils/assertIsDefined';

const INPUT_NAME_MESSAGE = 'Contact person inputs are rendered with a name';

export interface ContactPersonCardParams {}

interface Props extends ContactPersonCardParams {
    firstName: string;
    lastName: string;
    patronymic?: string;
    phone: string;
    isNew?: boolean;
    isFirstNameValid?: boolean;
    isLastNameValid?: boolean;
    isPatronymicValid?: boolean;
    isPhoneValid?: boolean;
    // showValidStatus?: boolean;
    onInputBlur(event: React.FocusEvent<HTMLInputElement>): void;
    onInputChange(value: string, name: string): void;
    onCountryChange(phone: string): void;
    onRemoveClick?(): void;
}

export function ContactPersonCard({
    firstName,
    lastName,
    patronymic = '',
    phone,
    isFirstNameValid,
    isLastNameValid,
    isPatronymicValid,
    isPhoneValid,
    isNew,
    onInputBlur,
    onInputChange,
    onCountryChange,
    onRemoveClick,
}: Props) {
    function contactPersonCard() {
        return (
            <div className={classnames([style.root, isNew && style.root_new])}>
                <div className={style.inputWrapper}>
                    <Input
                        value={lastName}
                        name={'lastName'}
                        title={translate('lastName')}
                        isValid={isLastNameValid}
                        notValidText={translate(lastName.length === 0 ? 'requiredField' : 'invalidName')}
                        showValidStatus={!isLastNameValid}
                        dataTest={EhrPageAttributes.ContactPersonLastName}
                        onChange={(event, name) => {
                            assertIsDefined(name, INPUT_NAME_MESSAGE);
                            onInputChange(event.target.value, name);
                        }}
                        onBlur={onInputBlur}
                    />
                </div>
                <div className={style.inputWrapper}>
                    <Input
                        value={firstName}
                        name={'firstName'}
                        title={translate('name')}
                        isValid={isFirstNameValid}
                        notValidText={translate(firstName.length === 0 ? 'requiredField' : 'invalidName')}
                        showValidStatus={!isFirstNameValid}
                        dataTest={EhrPageAttributes.ContactPersonFirstName}
                        onChange={(event, name) => {
                            assertIsDefined(name, INPUT_NAME_MESSAGE);
                            onInputChange(event.target.value, name);
                        }}
                        onBlur={onInputBlur}
                    />
                </div>
                <div className={style.inputWrapper}>
                    <Input
                        value={patronymic}
                        name={'patronymic'}
                        title={translate('patronymic')}
                        isValid={isPatronymicValid}
                        notValidText={translate('invalidName')}
                        showValidStatus={!isPatronymicValid}
                        dataTest={EhrPageAttributes.ContactPersonPatronymic}
                        onChange={(event, name) => {
                            assertIsDefined(name, INPUT_NAME_MESSAGE);
                            onInputChange(event.target.value, name);
                        }}
                        onBlur={onInputBlur}
                    />
                </div>
                <div className={style.inputWrapper}>
                    <PhoneInput
                        value={phone}
                        name={'phone'}
                        title={translate('phone')}
                        isValid={isPhoneValid}
                        notValidText={translate('requiredField')}
                        showValidStatus={!isPhoneValid}
                        dataTest={EhrPageAttributes.ContactPersonPhone}
                        onCountryChange={onCountryChange}
                        onChangeValue={onInputChange}
                        onBlur={onInputBlur}
                    />
                </div>
                {onRemoveClick && isNew && (
                    <CancelButton
                        label={translate('cancel')}
                        dataTest={EhrPageAttributes.ContactPersonCancel}
                        onCancelClick={onRemoveClick}
                    />
                )}
            </div>
        );
    }

    return isNew ? (
        contactPersonCard()
    ) : (
        <FoldingComponent
            content={`${lastName} ${firstName} ${patronymic} ${phone}`}
            controlDataTest={EhrPageAttributes.ContactPersonEdit}
            removeDataTest={EhrPageAttributes.ContactPersonRemove}
            onRemoveClick={onRemoveClick}
        >
            {contactPersonCard()}
        </FoldingComponent>
    );
}
